import * as React from "react";
import { IDocumentNameElement } from "../Document/DocumentsView";
import { IconType, MimeTypeIcon } from "../Icons/MimeTypeIcon";
import * as Utilities from "../Utilities";
import { Link } from "./Link";
import { TooltipHost, TooltipDelay, DirectionalHint, ITooltipProps } from 'office-ui-fabric-react';
import { DocumentPreviewIcon } from "../Icons/DocumentPreviewIcon";
import { FileResultInfo } from "../DocumentReader";
import { string } from "prop-types";  
import { NxSpinner } from "./Spinner";
import { action, computed, observable } from "mobx";
import { inject, observer } from "mobx-react";

interface ICoverPreviewProps {
	isCoverAvailable?: boolean;
	fileLinkGuid?: string;
}

@observer
export class CoverPreview extends React.Component<ICoverPreviewProps, {}> {
	@observable isBusy = true;
	private imageLoadCompleted = () => {
		this.isBusy = false;
	}

	render() {
		let fileResult: FileResultInfo = new FileResultInfo();
		fileResult.isCoverAvailable = this.props.isCoverAvailable;
		fileResult.fileLinkGuid = this.props.fileLinkGuid;
		return (<div style={{
			minWidth: 200, minHeight: 150, maxWidth: 200, maxHeight: 150
		}}>
			 
			<NxSpinner isBusy={this.isBusy} />
			<DocumentPreviewIcon fileResult={fileResult} imageLoadComplete={this.imageLoadCompleted} /></div>
		);
	}
}